import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RequestServiceProvider } from '../../providers/request-service/request-service';
import { LoadingProvider } from '../../providers/loading/loading';
import { TransactionAlertProvider } from '../../providers/transaction-alert/transaction-alert';

/**
 * Generated class for the ExternalCashoutPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-external-cashout',
  templateUrl: 'external-cashout.html',
})
export class ExternalCashoutPage {

  extCashoutForm:FormGroup;
  submitAttempt = false;
  public postData ;
  public type: string = this.navParams.get('type');

  constructor(public navCtrl: NavController, public navParams: NavParams,private formBuilder: FormBuilder, private request: RequestServiceProvider, private alertCtrl: AlertController, private load: LoadingProvider, private transAlert: TransactionAlertProvider) {

    this.extCashoutForm = this.formBuilder.group({
      amount: ['',Validators.required],
      recipientPhone:['',Validators.compose([Validators.minLength(11),Validators.maxLength(11),Validators.required])],
      voucher:['',Validators.required]
      });

    //  console.log(this.navParams.get('type'))

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ExternalCashoutPage');
  }


  confirm() {

    this.submitAttempt = true;
    
    if(this.extCashoutForm.valid) {

      this.load.presentLoading('Verifying...');
      
      const terminal = {terminalId:this.navParams.get('type')};

      const data = {...this.extCashoutForm.value, ...terminal};

      this.postData = data ;
     // console.log(data);
      this.request.postExtCashoutValidate(data).subscribe(data => 
        {
          this.load.loader.dismiss().catch(()=>{}) ;
          if(data.json().responseCode === "0000"){

            if(data.json().fullName){
              this.postData.fullName = data.json().fullName
            }
            
            this.nextPage();
          }else{
            
            this.transAlert.presentNormalErrorAlert(data.json().responseDescription)
          }
        },
      error => {
        this.load.loader.dismiss().catch(()=>{}) ;
        }
      )
    }
  }


  nextPage() {
    this.navCtrl.push("ConfirmTransactionPage", {
      form:this.postData,
      button:'Cash Out',
      transaction:8
    })
  }


}



// WEBPACK FOOTER //
// ./src/pages/external-cashout/external-cashout.ts